export default __webpack_public_path__ + "static/media/download_bg1.30850853.png";